module.exports = __webpack_public_path__ + "static/media/specular_logo_transparent.67e849d0.png";